export class MenuConstants{
    static HOME:string = "home";
    static PRODUCTS:string = "products";
    static COMMUNICATIONS:string = "communications";
    static PROMOTIONS:string = "promotions";
    static REPORTS:string = "reports";
    static TRAINING:string = "training";
    static HEALTHFAIR:string = "healthFair";
    static DASHBOARD:string = "dashboard";
    static CONTACTUS:string = "contactUs";
    static CHANGEACCOUNT:string = "changeAccount";
    static LOGOUT:string = "logout";
    static OVERVIEW:string = "overview";
    static PROGRAMS:string = "programs";
    static SALESINFO:string = "salesInfo";
    static ACCOUNTS_PORTFOLIO:string = "accountsPortfolio";
    static ACCOUNTS:string = "accounts";
    static SALESOFFICES:string = "salesOffices";
    static USERS:string = "users";
    static CLIENTFEEDBACK:string = "clientFeedback";
    static MANAGE_EVENTS = "manageEvents";
    static MYDASHBOARD = "myDashboard";
    static CHANGEPASSWORD = "changePassword";
}
